import { render, staticRenderFns } from "./PreviousList.vue?vue&type=template&id=fa99f948&scoped=true&"
import script from "./PreviousList.vue?vue&type=script&lang=js&"
export * from "./PreviousList.vue?vue&type=script&lang=js&"
import style0 from "./PreviousList.vue?vue&type=style&index=0&id=fa99f948&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa99f948",
  null
  
)

export default component.exports